import { useState, useEffect } from 'react';
import api from '../../../services/api';
import './style.css';
import { Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../../components/FormGroup';
import { Label } from '../../../components/Label';
import { CardContent } from '../../../components/CardContent';
import { Title } from '../../../components/Title';
import { Subtitle } from '../../../components/SubTitle';
import { TBody, TCell, TGroup, THeader, TRow, Table, ThCell } from '../../../components/Table/Table';
import { format, isValid, parseISO } from 'date-fns';
import { ptBR, th } from 'date-fns/locale';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Box, Skeleton, TextField, TextareaAutosize, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { FillPen } from '../../../components/Icons';
import { PgrGerarDocumento } from '../GerarDocumento';
import AlertMessage from '../../../components/Alert';
import { DeleteModal } from '../../../components/ModalDelete';
import { useLocation } from 'react-router-dom';
import { Modal as MaterialModal } from '@mui/material';
import { traduzirIntervaloCronograma } from '../../../utils/traduzirMes';
import { NiveisAcesso } from '../../../constants/niveisAcesso';

export function PgrCronograma({ idEmpresa, idFdt, idRevisao, idGhe, funcoes, selectedEmissaoId, documento, externoPgr, externoPcmso, enviado }: any) {
    // Estado para armazenar as ações do cronograma
    const [acoes, setAcoes] = useState<any>([]);
    const [novaAcao, setNovaAcao] = useState({ nome: '', responsavel: '', dataExecucao: '' });
    const [intervalosCronograma, setIntervalosCronograma] = useState<any[]>([]);
    const [execucoesCronograma, setExecucoesCronograma]: any = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editedAcao, setEditedAcao]: any = useState({});
    const [editedExecucoes, setEditedExecucoes] = useState([...execucoesCronograma]);
    const [responsaveis, setResponsaveis]: any = useState([]);
    const [responsavelSelecionado, setResponsavelSelecionado]: any = useState(null);
    const [alerts, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [acaoEmEdicao, setAcaoEmEdicao] = useState(null);
    const [dataSelecionada, setDataSelecionada] = useState(false);
    const location = useLocation();
    const [nivelAcesso, setNivelAcesso] = useState(0)
    const pathName = location.pathname;
    const routeName = pathName.substring(pathName.lastIndexOf('/') + 1).toUpperCase();
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [quarentenaAcoes, setQuarentenaAcoes]: any = useState([]);
    const [nome, setNome]: any = useState('');
    const [responsavel, setResponsavel]: any = useState('');
    const [dataExecucao, setDataExecucao]: any = useState('');
    const [quarentenaExecucoes, setQuarentenaExecucoes]: any = useState([]);
    const [quarentenaError, setQuarentenaError] = useState(false);
    const [quaretenaExecucao, setQuarentenaExecucao] = useState(false);

    useEffect(() => {
        const fetchNivelAcesso = async () => {
            try {
                const response = await api.get('nivel-acesso');
                setNivelAcesso(response.data.nivel);
            } catch (error) {
                console.error('Erro ao buscar nível de acesso:', error);
            }
        };
        fetchNivelAcesso()
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.post('listar-pgr', { id_empresa: idEmpresa, id_fdt: idFdt, id_revisao: idRevisao, id_ghe: idGhe, tipo_documento: routeName });
            // for (const action of response.data.acoes_cronograma) {
            //     if (action.execucoes.length >= 12) {
            //         action.execucoes = action.execucoes.slice(0, 12);
            //     }
            // }
            setAcoes(response.data.acoes_cronograma);

            setIntervalosCronograma(traduzirIntervaloCronograma(response.data.intervalo_cronograma));
            if (response.data.execucoes_cronograma && response.data.execucoes_cronograma.length > 0) {
                const execucoes = response.data.execucoes_cronograma.map((execucao: any) => ({
                    ...execucao,
                    executada: execucao.executada === 1,
                }));
                setExecucoesCronograma(execucoes);
            }
        } catch (error) {
            console.error('Erro ao buscar dados', error);
        }

    };

    useEffect(() => {
        fetchData();
    }, [idEmpresa, idFdt, idRevisao, idGhe]);


    useEffect(() => {
        const fetchResponsaveis = async () => {
            try {
                const response = await api.get('listar-responsaveis');
                setResponsaveis(response.data);
            } catch (error) {
                console.error('Erro ao buscar responsáveis', error);
            }
        };

        fetchResponsaveis();
    }, []);

    useEffect(() => {
        api.post('get-quarentena-acoes-cronograma', acoes).then((response: any) => {
            const acoesQuarentena = response.data.flat();
            setQuarentenaAcoes(acoesQuarentena);
        })
    }, [acoes]);

    useEffect(() => {
        api.post('get-quarentena-execucoes-cronograma', acoes).then((response: any) => {
            const riscosQuarentena = response.data.flat();
            setQuarentenaExecucoes(riscosQuarentena);
        })
    }, [acoes]);

    /*Checkbox*/
    const handleCheckboxChange = async (acaoId: any, execucaoId: any) => {
        const acoesAtualizadas: any = acoes.map((acao: any) => {
            if (acao.id === acaoId) {
                return {
                    ...acao,
                    execucoes: acao.execucoes.map((execucao: any) => {
                        if (execucao.id === execucaoId) {
                            const novaExecucao = { ...execucao, executada: execucao.executada == 1 ? 0 : 1 };
                            updateExecucao(acaoId, novaExecucao);
                            return novaExecucao;
                        }
                        return execucao;
                    })
                };
            }
            return acao;
        });

        if (editMode) {
            console.log('Modo Edição')
        } else {
            setAcoes(acoesAtualizadas);
        }

    };

    const updateExecucao = async (acaoId: any, execucao: any) => {
        try {
            const payload = {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_revisao: idRevisao,
                id_ghe: idGhe,
                id_acao: acaoId,
                id_execucao: execucao.id
            };
            await api.post('atualizar-execucao', payload);
            await fetchData();

            console.log('Execução atualizada com sucesso!');

        }


        catch (error) {
            console.error('Erro ao atualizar execução', error);
        }
    };

    const handleEditClick = (acao: any) => {
        setEditMode(true);
        setEditedAcao({ ...acao });
        setEditedExecucoes([...execucoesCronograma]);
        setAcaoEmEdicao(acao);
    };

    const handleCancelEdit = () => {
        setEditMode(false);
    };

    const handleSaveEdit = async () => {
        try {
            if (editedAcao.data_inicial && new Date(editedAcao.data_inicial) < new Date()) {
                setAlert({ show: true, message: `A data selecionada não pode ser anterior à data de hoje`, variant: "danger" });
                return;
            }
            const responseAcao = await api.post('editar-acao', { ...editedAcao, idEmpresa });

            const execucoesComIdAcao = editedExecucoes.map(execucao => ({
                ...execucao,
                id_fdt: idFdt
            }));

            const responseExecucoes = await api.post('editar-execucoes', { execucoes: execucoesComIdAcao, idEmpresa });
            setAlert({ show: true, message: 'Dados alterados com sucesso!', variant: 'success' });

            if (responseAcao.data && responseExecucoes.data) {
                alert(`${responseAcao.data.message}\n${responseExecucoes.data.message}`);

                fetchData();
            }

            setEditMode(false);
            setEditedAcao({});
            setEditedExecucoes([]);
            fetchData();
        } catch (error) {
            setAlert({ show: true, message: 'Erro ao alterar os dados', variant: 'danger' });
            console.error('Erro ao salvar alterações:', error);
        }
    };

    const [inputErrors, setInputErrors]: any = useState({ nome: false, responsavel: false, dataExecucao: false });

    const handleAddAction = async () => {
        if (dataExecucao && new Date(dataExecucao) < new Date()) {
            setAlert({ show: true, message: `A data selecionada não pode ser anterior à data de hoje`, variant: "danger" });
            return;
        }

        try {
            const payload = {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_revisao: idRevisao,
                id_ghe: idGhe,
                descricao: nome,
                responsavel: responsavel,
                data_execucao: dataExecucao || null,
                tipo_documento: routeName
            };

            const response = await api.post('inserir-acao', payload);
            console.log('Ação inserida com sucesso!', response.data);
            await fetchData(); // Atualiza a lista de ações
            setNome('');
            setDataExecucao('');
            setResponsavel('');
            setResponsavelSelecionado(null);
        } catch (error) {
            console.error('Erro ao inserir ação', error);
        }
    };


    const handleDeleteConfirm = async () => {
        await fetchData();
    };

    const handleCloseHelpModal = () => {
        setShowHelpModal(false);
    };

    const getExternoBasedOnRoute = () => {
        if (routeName === 'PGR') {
            return externoPgr;
        } else if (routeName === 'PCMSO') {
            return externoPcmso;
        }
        return null;
    };

    const externo = getExternoBasedOnRoute();

    return (
        <div className='py-4'>
            {/* {externo == 1 ? (
                <div style={{ position: 'relative', width: '100%' }}>
                    <Skeleton variant="rectangular" width="100%" height={500} animation="wave" style={{ backgroundColor: '#E6E6E6', borderRadius: '10px' }} />
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        textAlign: 'center',
                        color: 'grey',
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}>

                        Para mais funcionalidades, adquira uma revisão ou inicie uma nova frente de trabalho.
                    </div>
                </div>

            ) : ( */}
            <div id={documento === 'PGR' ? "pgrStep4" : ''}>
                <CardContent>
                    {documento === 'PGR' ? (
                        <>
                            <Row>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}>
                                    <Title text="Cronograma de Ação Nesta Revisão Deste PGR" />
                                    <Button
                                        style={{
                                            width: '40px',
                                            borderRadius: '20px',
                                        }}
                                        onClick={() => setShowHelpModal(true)}>
                                        ?
                                    </Button>
                                </Box>
                                <p style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '0.2%' }}>Ajuda</p>
                            </Row>

                            {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                                <>
                                    <Subtitle text="Inserir Nova Ação Planejada" />
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup className={`form-group-dsg`}>
                                                <Label title="NOME" htmlFor="nomeAcao" />
                                                <input
                                                    type="text"
                                                    name="nome"
                                                    value={nome}
                                                    onChange={(e) => setNome(e.target.value)}
                                                    style={{ width: "100%" }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className='form-group-dsg'>
                                                <Label title="RESPONSÁVEL" htmlFor="respAcao" />
                                                <input
                                                    type="text"
                                                    name="responsavel"
                                                    value={responsavel}
                                                    onChange={(e) => setResponsavel(e.target.value)}
                                                    style={{ width: "100%" }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup className='form-group-dsg'>
                                                <Label title="DATA DE EXECUÇÃO" htmlFor="dataExec" />
                                                <input
                                                    type="date"
                                                    name="dataExecucao"
                                                    value={dataExecucao}
                                                    onChange={(e) => setDataExecucao(e.target.value)}
                                                    style={{ width: "100%" }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={1}>
                                            <div className="d-grid justify-content-center">
                                                &nbsp;
                                                <Button variant='success' onClick={handleAddAction}>
                                                    Adicionar
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <Row>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}>
                                    <Title text="Cronograma de Ação Nesta Revisão Deste PCSMO" />
                                    <Button
                                        style={{
                                            width: '40px',
                                            borderRadius: '20px',
                                        }}
                                        onClick={() => setShowHelpModal(true)}>
                                        ?
                                    </Button>
                                </Box>
                                <p style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '0.2%' }}>Ajuda</p>
                            </Row>

                            {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                                <>
                                    <Subtitle text="Inserir Nova Ação Planejada" />
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup className={`form-group-dsg`}>
                                                <Label title="NOME" htmlFor="nomeAcao" />
                                                <input type="text" name="nome" value={nome} onChange={(e) => setNome(e.target.value)} style={{ width: "100%" }} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className='form-group-dsg'>
                                                <Label title="RESPONSÁVEL" htmlFor="respAcao" />
                                                <input type="text" name="responsavel" value={responsavel} onChange={(e) => setResponsavel(e.target.value)} style={{ width: "100%" }} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup className='form-group-dsg'>
                                                <Label title="DATA DE EXECUÇÃO" htmlFor="dataExec" />
                                                <input type="date" name="dataExecucao" value={dataExecucao} onChange={(e) => setDataExecucao(e.target.value)} style={{ width: "100%" }} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={1}>
                                            <div className="d-grid justify-content-center">
                                                &nbsp;
                                                <Button variant='success' onClick={handleAddAction}>
                                                    Adicionar
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}

                        </>)}

                    <Row className='acao-planejada mt-4'>
                        <Col md={12}>
                            <div className='pgr-new-table-container' style={{ marginBottom: '20px' }}>
                                <div className='pgr-new-table-container-scroll'>
                                    <table className='pgr-new-table-table'>
                                        <thead>
                                            <th className='pgr-new-table-th'>Ação Planejada</th>
                                            {intervalosCronograma.map((intervalo: any, index: number) => (
                                                <th key={index} className='pgr-new-table-th'>{intervalo.intervalo_execucoes}</th>
                                            ))}
                                        </thead>
                                        <Tooltip title={quarentenaError ? 'Ação adicionada manualmente' : ''}
                                            className={quarentenaError ? "pgr-new-table-tooltip" : "pgr-new-table-tooltip"}>
                                            <tbody className={quarentenaError ? 'quarentena-error border-radious-6' : ''}>
                                                {acoes.map((acao: any, index: number) => {
                                                    let isQuarentenaAcao: any = false
                                                    if (nivelAcesso == NiveisAcesso.ADMIN) {
                                                        isQuarentenaAcao = quarentenaAcoes.some((q: any) => q.id_registro === acao.id);
                                                    }
                                                    if (isQuarentenaAcao && !quarentenaError) setQuarentenaError(isQuarentenaAcao);
                                                    return (
                                                        <>
                                                            <tr key={index}>
                                                                <td className='pgr-new-table-td'>
                                                                    {editMode && acaoEmEdicao === acao ? (
                                                                        <TextareaAutosize
                                                                            className='editTextArea'
                                                                            value={editedAcao.descricao}
                                                                            onChange={(e) => {
                                                                                const updatedAcao = { ...editedAcao, descricao: e.target.value };
                                                                                setEditedAcao(updatedAcao);
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        acao.descricao
                                                                    )}
                                                                </td>
                                                                {acao.execucoes.map((execucao: any) => {
                                                                    let isQuarentenaExecucao: any = false
                                                                    if (nivelAcesso == NiveisAcesso.ADMIN) {
                                                                        isQuarentenaExecucao = quarentenaExecucoes.some((q: any) => q.id_registro === execucao.id);
                                                                    }
                                                                    if (isQuarentenaExecucao && !quaretenaExecucao) setQuarentenaExecucao(isQuarentenaExecucao);
                                                                    return (
                                                                        <td className='pgr-new-table-td'>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={execucao.executada === 1}
                                                                                onChange={() => handleCheckboxChange(acao.id, execucao.id)}
                                                                                className={quaretenaExecucao ? 'quarentena-error' : ''}
                                                                                disabled={externo == 1}
                                                                            />
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={2} className='pgr-new-table-td'>
                                                                    <div className='pgr-new-table-res-data-exec'>
                                                                        <div>
                                                                            RESPONSÁVEL: {editMode && acaoEmEdicao === acao ? (
                                                                                <input
                                                                                    className='editInput'
                                                                                    value={editedAcao.responsavel || ''} // Usa valor editado se disponível
                                                                                    onChange={(e) => setEditedAcao({ ...editedAcao, responsavel: e.target.value })}
                                                                                />
                                                                            ) : acao.responsavel}
                                                                        </div>
                                                                        <div>
                                                                            DATA DE EXECUÇÃO: {editMode && acaoEmEdicao === acao ? (
                                                                                <input
                                                                                    className='editInput'
                                                                                    type="date"
                                                                                    value={editedAcao.data_inicial || ''} // Usa valor editado se disponível
                                                                                    onChange={(e) => setEditedAcao({ ...editedAcao, data_inicial: e.target.value })} // Corrigido para usar editedAcao
                                                                                />
                                                                            ) : (acao.data_inicial ? format(parseISO(acao.data_inicial), 'dd/MM/yyyy', { locale: ptBR }) : '')}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                {/* <td colSpan={1} className='pgr-new-table-td'>
                                                
                                            </td> */}
                                                                <td colSpan={12} className='pgr-new-table-td'>
                                                                    <div className='pgr-new-table-td-buttons'>
                                                                        {editMode && acaoEmEdicao === acao ? (
                                                                            <>
                                                                                <Button variant='secondary' style={{ float: 'right' }} onClick={handleCancelEdit}>
                                                                                    Cancelar
                                                                                </Button>
                                                                                <Button variant='primary' className='btn-primary' style={{ float: 'right' }} onClick={handleSaveEdit}>
                                                                                    Salvar
                                                                                </Button>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {acao.editavel != false || nivelAcesso == NiveisAcesso.ADMIN ? (
                                                                                    <>
                                                                                        {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                                                                                            <>
                                                                                                <Button variant='outline-primary' className='btn-outline-main'
                                                                                                    onClick={() => handleEditClick(acao)}>
                                                                                                    Editar
                                                                                                    <FillPen />
                                                                                                </Button>
                                                                                                <DeleteModal
                                                                                                    endpoint='excluir-acao'
                                                                                                    onConfirm={handleDeleteConfirm}
                                                                                                    requestBody={{ id_fdt: idFdt, id_revisao: idRevisao, id_empresa: idEmpresa, id: acao.id, id_ghe: idGhe, tipo_documento: routeName }} />
                                                                                            </>
                                                                                        )}

                                                                                    </>
                                                                                ) : (
                                                                                    <Typography>Não Editável</Typography>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    );
                                                })}
                                            </tbody>
                                        </Tooltip>
                                    </table>
                                </div>
                            </div>
                            {/* <Table className='table-row-cronograma' style={{ marginTop: '20px' }}>
            <THeader>
                <ThCell>Ação Planejada</ThCell>
                {
                    intervalosCronograma.map((intervalo: any, idx: any) => (
                        <TCell key={`intervalos-${idx}`}>
                            {intervalo.intervalo_execucoes}
                        </TCell>
                    ))
                }

            </THeader>
            <TBody className='table-row-cronograma'>
                {acoes.map((acao: any, index: number) => {
                    let isQuarentenaAcao: any = false
                    if (nivelAcesso == NiveisAcesso.ADMIN) {
                        isQuarentenaAcao = quarentenaAcoes.some((q: any) => q.id_registro === acao.id);
                    }
                    return (
                        <Tooltip title={isQuarentenaAcao ? 'Ação adicionada manualmente' : ''}>
                            <div className={isQuarentenaAcao ? 'quarentena-error' : ''}>
                                <TGroup key={index}>
                                    <TRow >
                                        <TCell>
                                            {editMode && acaoEmEdicao === acao ? (
                                                <TextareaAutosize
                                                    className='editTextArea'
                                                    value={editedAcao.descricao}
                                                    onChange={(e) => {
                                                        const updatedAcao = { ...editedAcao, descricao: e.target.value };
                                                        setEditedAcao(updatedAcao);
                                                    }}
                                                />
                                            ) : (
                                                acao.descricao
                                            )}
                                        </TCell>
                                        {acao.execucoes.map((execucao: any) => {
                                            let isQuarentenaExecucao: any = false
                                            if (nivelAcesso == NiveisAcesso.ADMIN) {
                                                isQuarentenaExecucao = quarentenaExecucoes.some((q: any) => q.id_registro === execucao.id);
                                            }
                                            return (
                                                <Tooltip title={isQuarentenaExecucao ? 'Execução editada' : ''}>
                                                    <TCell key={execucao.id}>
                                                        <input
                                                            type="checkbox"
                                                            checked={execucao.executada === 1}
                                                            onChange={() => handleCheckboxChange(acao.id, execucao.id)}
                                                            className={isQuarentenaExecucao ? 'quarentena-error' : ''}
                                                        />
                                                    </TCell>
                                                </Tooltip>

                                            );
                                        })}

                                    </TRow>
                                    <TRow>
                                        <TCell>RESPONSÁVEL: {editMode && acaoEmEdicao === acao ? (
                                            <input
                                                className='editInput'
                                                value={editedAcao.responsavel || ''} // Usa valor editado se disponível
                                                onChange={(e) => setEditedAcao({ ...editedAcao, responsavel: e.target.value })}
                                            />
                                        ) : acao.responsavel}</TCell>
                                        <TCell>
                                            <div className={editMode && acaoEmEdicao === acao ? 'cell-margin-left' : ''}>
                                                DATA DE EXECUÇÃO: {editMode && acaoEmEdicao === acao ? (
                                                    <input
                                                        className='editInput'
                                                        type="date"
                                                        value={editedAcao.data_inicial || ''}
                                                        onChange={(e) => setEditedAcao({ ...acao, data_inicial: e.target.value })} />) :
                                                    (acao.data_inicial ? format(parseISO(acao.data_inicial), 'dd/MM/yyyy', { locale: ptBR }) : '')}
                                            </div>
                                        </TCell>
                                        <TCell className="action-functions">
                                            {editMode && acaoEmEdicao === acao ? (
                                                <>
                                                    <Button variant='secondary' style={{ float: 'right' }} onClick={handleCancelEdit}>
                                                        Cancelar
                                                    </Button>
                                                    <Button variant='primary' className='btn-primary' style={{ float: 'right' }} onClick={handleSaveEdit}>
                                                        Salvar
                                                    </Button>
                                                </>
                                            ) : (
                                                <>
                                                    {acao.editavel != false || nivelAcesso == NiveisAcesso.ADMIN ? (
                                                        <>
                                                            <Button variant='outline-primary' className='btn-outline-main' style={{ float: 'right' }} onClick={() => handleEditClick(acao)}>
                                                                Editar
                                                                <FillPen />
                                                            </Button>
                                                            <DeleteModal
                                                                endpoint='excluir-acao'
                                                                onConfirm={handleDeleteConfirm}
                                                                requestBody={{ id_fdt: idFdt, id_revisao: idRevisao, id_empresa: idEmpresa, id: acao.id, id_ghe: idGhe, tipo_documento: routeName }} />
                                                        </>
                                                    ) : (
                                                        <Typography>Não Editável</Typography>
                                                    )}
                                                </>
                                            )}
                                        </TCell>
                                    </TRow>
                                </TGroup>
                            </div>
                        </Tooltip>
                    );
                })}
            </TBody>
        </Table> */}
                        </Col>
                    </Row>
                </CardContent>
            </div>
            {/* )} */}

            <PgrGerarDocumento idEmpresa={idEmpresa} idFdt={idFdt} idRevisao={idRevisao} idGhe={idGhe} funcoes={funcoes} selectedEmissaoId={selectedEmissaoId} documento={documento} externoPgr={externoPgr} externoPcmso={externoPcmso} enviado={enviado} />
            <AlertMessage
                show={alerts.show}
                message={alerts.message}
                variant={alerts.variant}
                onClose={() => setAlert({ ...alerts, show: false })}
            />
            <MaterialModal
                open={showHelpModal}
                onClose={handleCloseHelpModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'block',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '700px',
                    maxWidth: '90%',
                    maxHeight: '80%'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <h4>AJUDA</h4>
                        <p>
                            <b>Cronograma de Ação:</b>
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <p>
                                <b>Nome: </b> Nome da ação a ser realizada.
                            </p>
                            <p>
                                <b>Responsável:</b> Nome do responsável da empresa selecionada.
                            </p>
                            <p>
                                <b>Data de Execução:</b> Data de realização da ação.
                            </p>
                            <p>
                                <b>Inserção do Cronograma:</b> Ao criar um novo cronograma, ele já estará preenchido com configurações padronizadas determinadas pelo administrador do sistema.
                            </p>
                        </div>

                    </Box>
                </Box>
            </MaterialModal>
        </div >
    );
}
